__turbopack_context__.v({
  "active": "T1kspq_active",
  "content": "T1kspq_content",
  "horizontal": "T1kspq_horizontal",
  "noReasonButton": "T1kspq_noReasonButton",
  "root": "T1kspq_root",
});
